import { useEffect } from "react";
import { SERVER_URL } from "../config/config";

export const DEFAULT_STATION_FROM_NAME = "Ahmedabad";
export const DEFAULT_STATION_TO_NAME = "Mumbai";

export async function findBranchByName(name, companyId) {
  const response = await fetch(SERVER_URL + "/branch/", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      search: "like",
      limit: "10",
      companyId,
    }),
  }).catch((err) => {
    console.log({ err });
  });

  if (!response || !response.ok) return null;

  const branchList = await response.json();
  if (!Array.isArray(branchList)) return null;

  const target = String(name).trim().toLowerCase();
  return (
    branchList.find(
      (branch) =>
        String(branch["name"] ?? "").trim().toLowerCase() === target
    ) ||
    branchList.find((branch) =>
      String(branch["name"] ?? "")
        .trim()
        .toLowerCase()
        .startsWith(target)
    ) ||
    null
  );
}

export async function resolveDefaultStations(companyId) {
  const [from, to] = await Promise.all([
    findBranchByName(DEFAULT_STATION_FROM_NAME, companyId),
    findBranchByName(DEFAULT_STATION_TO_NAME, companyId),
  ]);

  if (!from) {
    console.warn(
      "default station from not found:",
      DEFAULT_STATION_FROM_NAME
    );
  }
  if (!to) {
    console.warn("default station to not found:", DEFAULT_STATION_TO_NAME);
  }

  return { from, to };
}

export function useDefaultStationTo({
  client,
  companyId,
  setPageState,
  userName,
  withDestination = false,
}) {
  useEffect(() => {
    if (client !== "syt") return;

    let isCancelled = false;

    findBranchByName(DEFAULT_STATION_TO_NAME, companyId).then((branch) => {
      if (isCancelled) return;
      if (!branch) {
        console.warn("default station to not found:", DEFAULT_STATION_TO_NAME);
        return;
      }

      const stationToState = {
        station_to: String(branch.branch_id),
        station_to_name: branch.name,
      };
      if (withDestination) {
        stationToState.destination = String(branch.branch_id);
        stationToState.destination_name = branch.name;
      }

      setPageState((oldState) => ({ ...oldState, ...stationToState }));
    });

    return () => {
      isCancelled = true;
    };
  }, [userName]);
}
